import Swiper from 'swiper';

const Sliders = () => {

    var swiper = new Swiper(".opinions-slider-js", {
        slidesPerView: "auto",
        spaceBetween: 30,
        autoplay: {
            delay: 3000,
        },
        loop: true
    });

    var swiper2 = new Swiper(".support-slider", {
        slidesPerView: "auto",
        spaceBetween: 30,
        autoplay: {
            delay: 3000,
        },
        loop: true
    });
    var swiper3 = new Swiper(".free-app-slider", {
        slidesPerView: "auto",
        autoplay: {
            delay: 3000,
        },
        loop: true
    });

    var swiper4 = new Swiper(".important-slider-js", {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
            delay: 3000,
        },
        loop: true,
        breakpoints: {
            // when window width is >= 320px
            575: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            // when window width is >= 480px
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            // when window width is >= 1200px
            1200: {
              slidesPerView: 4,
              spaceBetween: 40,
            }
          }
    });

    var swiper5 = new Swiper(".support__documents-slider", {
        slidesPerView: "auto",
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 16,
    });

    var swiperBlog = new Swiper(".latest-blog__slider-js", {
        slidesPerView: 1,
        spaceBetween: 30,
        autoplay: {
            delay: 3000,
        },
        loop: true,
        pagination: {
            el: ".swiper-pagination",
        },
        breakpoints: {
            575: {
                slidesPerView: 2,
            },
            875: {
              slidesPerView: 3,
            }
        }
    });

    var swiperLogos = new Swiper(".logos-slider-js", {
        slidesPerView: 2,
        spaceBetween: 30,
        autoplay: {
            delay: 2000,
        },
        loop: true,
        breakpoints: {
            450: {
                slidesPerView: 3,
            },
            550: {
              slidesPerView: 4,
            }
        }
    });

}

export default Sliders;